var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 637,
    height: 412,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEFC9",
    d: "M0 0h637v412H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A2BB12",
    d: "M302.94 298.1a35.81 35.81 0 0 1 34.43 25.94h-68.8a35.64 35.64 0 0 1 34.37-25.94ZM209.02 298.1a35.81 35.81 0 0 1 34.43 25.94h-68.8a35.74 35.74 0 0 1 34.37-25.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2BB12",
    d: "M253.76 286.97a51.04 51.04 0 0 1 49.13 37.07h-98.32a51.23 51.23 0 0 1 49.19-37.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#879E0C",
    d: "M174.42 343.3h163.13c6.03 0 10.95-4.91 10.95-10.94 0-6.04-4.92-10.96-10.95-10.96H174.42a10.97 10.97 0 0 0-10.95 10.96c0 6.03 4.92 10.95 10.95 10.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D452C",
    d: "M245.85 201.83h20.32v129.82h-20.32V201.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ABB00",
    d: "M95.55 103.22c2.4-4.98 6.5-8.5 10.77-12.42a37.74 37.74 0 0 1 4.4-3.16c12.17-7.5 27.98-7.79 42.8-2.34 1.98.06 3.86.17 5.8.35 18.96 1.7 35.83 8.72 55.38 4.57 11.83-2.52 25.12-15.23 35.55-21.09 10.42-5.85 26.05-10.42 38.11-10.83 13.41-.4 31.1 13.06 36.83 24.54 6.97 13.93 4.92 33.26 14.58 45.5 8.79 11.12 18.1 22.66 31.39 28.63 7.73 3.46 16.4 4.75 24 8.38 8.09 3.8 17.16 10.07 23.72 17.45a43.52 43.52 0 0 1 3.57 4.56 52.3 52.3 0 0 1 7.03 18.1c.3 1.64.53 3.28.7 4.92.3 12.59-.88 26.06-12 34.25-9.37 6.45-21.08 5.28-27.93 13.65a112 112 0 0 0-2.87 4.33c-1.87 2.93-3.75 5.86-6.09 8.38-11.13 12.3-29.28 12.3-44.33 9.37a90.18 90.18 0 0 1-5.73-.88c-3.17-.53-6.21-1.23-9.31-1.94l-4.57-1.05c-19.85-6.09-40.35-13.12-60.9-4.4-1.93.54-3.8 1.12-5.68 1.65-9.3 2.75-18.5 5.68-28.05 6.44-1.93.12-3.8.18-5.73.12-7.62-.18-15.29-1.53-22.66-2.46-2.23-.47-4.4-1-6.5-1.64-16.63-5.5-29.1-20.67-31.8-38.53a29.8 29.8 0 0 1-.23-3.99c0-1.34.11-2.75.29-4.21a38.7 38.7 0 0 0-.53-3.98c-.88-3.75-2.57-7.03-6.09-8.67a12.75 12.75 0 0 0-5.03-1.11c-6.1.35-12.3.05-18.27-.94-2-.35-3.92-.76-5.92-1.23-22.95-4.63-37-23.95-39.05-46.85-.41-2.05-.7-4.04-1-6.09a79.74 79.74 0 0 1 2.35-29.51c.35-1.76.76-3.51 1.28-5.27a63.97 63.97 0 0 1 8.96-19.32l2.75-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADC318",
    d: "M97.42 109.07c8.37-19.62 28.22-35.49 50.7-36.71 24.01-1.3 43.63 9.77 67.11 4.8 11.83-2.52 25.12-15.23 35.54-21.08 10.42-5.86 26.06-10.43 38.12-10.84 13.41-.4 31.1 13.06 36.83 24.54 6.97 13.94 4.92 33.26 14.58 45.5 8.78 11.13 18.1 22.66 31.39 28.63 7.73 3.46 16.4 4.75 24 8.38 12.94 6.15 28.46 18.44 31.86 31.62 3.45 13.18 4.8 25.88 1.17 39.06-1.7 6.09-7.61 14.58-17.8 18.44-5.74 2.17-22.31-1-27.87 2-4.51 2.46-7.85 5.73-10.84 9.13-1 1.11-1.93 2.28-2.86 3.4-7.27 11.12-19.21 15.75-31.45 15.4-2.05-.06-4.1-.3-6.15-.59a50.58 50.58 0 0 1-9.9-2.22c-1.57-.53-3.16-1.06-4.74-1.64-19.03-10.6-40.1-8.84-60.3-5.1l-5.22.7c-8.72 1.12-17.45 1.64-26.47.7-2.04.07-4.15.07-6.2-.05-16.75-.88-33.96-7.73-39.58-25.3a31.77 31.77 0 0 1-1.3-5.97c-.28-1.76-.46-3.46-.64-4.98-.29-3.1-.35-5.56-.76-6.73-3.4-9.9-15.16-14.82-26.05-16.75-5.45-.94-11.07-1.46-16.52-2.46-1.81-.3-3.63-.7-5.38-1.11a37.27 37.27 0 0 1-22.49-11.66 52.58 52.58 0 0 1-3.92-4.86c-13.18-17.15-13.18-40-8.96-60.66.3-1.52.64-3.1 1.05-4.63a62.08 62.08 0 0 1 3.05-8.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D452C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 11,
    d: "m251.3 305.95-21.08-7.44M263.07 293.18s7.96-19.85 22.43-29.87"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B6614",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M168.56 142.57v-23.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D452D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M276.83 142.04h43.39"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B6614",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M267.05 93.44h-40.34M168.56 119.32h151.25M247.5 93.44v25.88M319.8 142.57v-23.25M211.07 142.57h-42.5M189.82 191v-48.43M298.55 191v-48.96M298.55 165.87h83.5v25.24M341.06 192.75v-26.88M298.55 191H255.7M277.24 239.13V191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#879E0C",
    d: "M269.04 109.07a14.52 14.52 0 1 1 0-29.04 14.52 14.52 0 0 1 0 29.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M274.72 118.5H262.9v-13.06a5.9 5.9 0 0 1 5.92-5.91 5.9 5.9 0 0 1 5.91 5.91v13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M271.62 93.67c-1.4 3.51-5.04 5.39-7.2 4.5-2.17-.87-2.05-4.15-.6-7.66 1.42-3.52 3.93-4.63 6.04-3.75 2.17.88 3.16 3.4 1.76 6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M272.73 95.54c-.35.82-1.58 1.53-2.17 1.3-.58-.24-.46-.94-.11-1.76.35-.82 1.1-1.41 1.7-1.18.58.24.87.82.58 1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M273.02 91.62s.18-2.58-1.23-4.1c-1.4-1.52-4.86-2.75-6.9.06 0 0-1.24 2.1 1.46 3.4 2.7 1.29 2.7-.35 3.63 1.46.94 1.82 2.52 1.23 2.63 1.64l.41-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m271.03 93.79-3.98-.41c-.06.52-.47 5.74-.3 7.67.12.58 1.12.88 2.23.64 1-.23 1.64-.82 1.7-1.34-.12-1.18.12-4.63.35-6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M269.92 95.13c-.7-.52-1.11.18-2.34 1.18-1.23 1.05-3.75 1.34-4.57-1.88-.53-2.05-1 1.58-1 1.58.12 1.76.76 2.7 2.05 3.16 1.76.7 4.22.12 6.21-1.63.12-.94.12-2.05-.35-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M262.9 94.31s.05 0 .11.06c.76.24 4.16 1.4 4.74 2.58.65 1.35-1.75-.23-2.57-1.05-.76-.82-1.53-.53-2.23-.59-.64-.06-1.11-.82-.06-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M275.83 118.5c-.52-3.1-2.16-6.73-5.03-11.83-2.4-4.33 2.28-6.27 3.51-3.57 2.75 6.32 4.57 11.18 5.1 15.34h-3.58v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1C2E",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M266.06 92.32c-.24.59 0 1.23.58 1.53.59.23 1.23 0 1.52-.59.24-.59 0-1.23-.58-1.52-.59-.24-1.3 0-1.52.58ZM263.13 91.04c-.24.58 0 1.22.58 1.52.59.23 1.23 0 1.53-.59.23-.58 0-1.23-.6-1.52-.58-.23-1.28 0-1.51.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1C2E",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M266.4 91.86s-.34-.65-1.1-.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91AF00",
    d: "M226.47 109.07a14.52 14.52 0 1 1 0-29.04 14.52 14.52 0 0 1 0 29.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M231.27 117.03h-11.82v-13.05a5.9 5.9 0 0 1 5.91-5.92 5.9 5.9 0 0 1 5.91 5.92v13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M228.46 83.9a3.09 3.09 0 0 0-2.98 1.8c-.41 1.12.47 2.35 1.52 2.76 1.11.4 3.34-.76 3.75-1.88.4-1.1-.82-2.51-2.29-2.69ZM225.94 89.86c-1.58-1.28-4.27-1.64-5.9-.4-1.65 1.17-1.53 3.68-.3 5.32 1.17 1.64 5.39 2.29 7.02 1.12 1.65-1.18 1.12-4.46-.81-6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M223.43 91.97c1.52 3.28 5.03 4.86 7.02 3.93 2-.94 1.7-4.04.18-7.27-1.52-3.27-3.92-4.15-5.91-3.22-2 .88-2.81 3.28-1.3 6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M222.5 93.79c.34.76 1.57 1.4 2.1 1.11.53-.3.4-.94.06-1.7-.35-.76-1.12-1.29-1.7-1-.53.24-.82.83-.47 1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M221.96 90.1s-.29-2.4 1-3.93c1.29-1.52 4.5-2.86 6.5-.29 0 0 1.29 1.93-1.23 3.28-2.52 1.35-2.58-.23-3.34 1.58-.76 1.76-2.28 1.3-2.46 1.64l-.47-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m224.6 92.44 3.75.35c-.06.53-.59 5.39-1.12 7.2-.23.53-1.23.65-2.16.18-.88-.41-1.4-1.05-1.35-1.58.35-1.06.7-4.33.88-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M218.1 117.03c.53-3.1 2.16-6.73 5.03-11.82 2.4-4.34-2.28-6.27-3.5-3.58-2.76 6.33-4.58 11.19-5.1 15.35h3.57v.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1C2E",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M228.81 90.74c.24.59-.05 1.23-.64 1.47a1.12 1.12 0 0 1-1.46-.65c-.24-.58.05-1.23.64-1.46.59-.24 1.23.06 1.46.64ZM231.8 89.63c.23.59-.06 1.23-.64 1.46a1.12 1.12 0 0 1-1.47-.64c-.23-.59.06-1.23.65-1.46.58-.24 1.23.05 1.46.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1C2E",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M228.46 90.27s.41-.64 1.12-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#879E0C",
    d: "M211.07 157.09a14.52 14.52 0 1 1 0-29.04 14.52 14.52 0 0 1 0 29.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M218.63 165.46H206.8V152.4a5.9 5.9 0 0 1 5.91-5.91 5.9 5.9 0 0 1 5.92 5.91v13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M215.46 140.63c-1.4 3.52-5.03 5.4-7.2 4.51-2.16-.88-2.05-4.15-.58-7.67 1.4-3.51 3.92-4.62 6.03-3.75 2.22.88 3.22 3.34 1.75 6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M216.58 142.45c-.36.82-1.59 1.52-2.17 1.29-.59-.24-.47-.94-.12-1.76.35-.82 1.12-1.4 1.7-1.17.59.23.94.82.59 1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m214.88 140.75-3.98-.4c-.06.52-.47 5.73-.3 7.66.12.59 1.12.88 2.23.65 1-.24 1.64-.82 1.7-1.35-.12-1.23.17-4.68.35-6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M213.77 142.04c-.7-.53-1.12.18-2.35 1.17-1.23 1.05-3.74 1.35-4.56-1.87-.53-2.05-1 1.58-1 1.58.12 1.76.76 2.7 2.05 3.16 1.76.7 4.22.12 6.2-1.64.18-.88.12-2.05-.34-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M219.68 165.46c-.53-3.1-2.17-6.73-5.04-11.83-2.4-4.33 2.29-6.26 3.52-3.57 2.75 6.33 4.56 11.19 5.1 15.34h-3.58v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C2E",
    d: "M208.2 133.84c-.05-.17-.17-.35-.23-.47-.23-.58.17-1.28.7-1.58.53-.3 1.23-.17 1.88 0 .23.06.4.18.64.18.47.06.88-.12 1.35-.12a2.3 2.3 0 0 1 1.93.94c.17.23.4.64.53 1.05.23.18.46.35.64.59 1.4 1.52 1.23 4.1 1.23 4.1l-.41 2.46c-.18-.41-1.76.23-2.64-1.64-.93-1.82-.87-.18-3.63-1.47-1.28-.58-1.7-1.4-1.75-2.1l-.06-.06c-.18-.18-.41-.36-.47-.59-.06-.35.41-.82.3-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91AF00",
    d: "M168.56 157.09a14.52 14.52 0 1 1 0-29.04 14.52 14.52 0 0 1 0 29.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M166.16 138.18c.65-1.18.53-3.05-.47-4.05s-2.7-.64-3.69.3c-.93 1-1.23 3.45.18 5.1.94 1.05 3.1.17 3.98-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M174.71 166.46h-11.83V153.4a5.9 5.9 0 0 1 5.92-5.91 5.9 5.9 0 0 1 5.91 5.91v13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M171.9 133.31a3.09 3.09 0 0 0-2.99 1.82c-.4 1.17.47 2.34 1.53 2.75 1.1.41 3.33-.76 3.74-1.87.47-1.17-.82-2.58-2.28-2.7ZM169.5 139.35c-1.23-1-3.4-1.3-4.69-.35-1.28.93-1.17 2.92-.23 4.21s4.27 1.82 5.56.88c1.3-.94.94-3.46-.64-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M166.86 141.4c1.53 3.28 5.04 4.86 7.03 3.92 2-.94 1.7-4.04.18-7.26-1.53-3.28-3.93-4.16-5.92-3.22-1.93.88-2.8 3.28-1.29 6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M165.93 143.21c.35.76 1.58 1.4 2.1 1.11.53-.23.41-.93.06-1.7-.35-.76-1.1-1.28-1.7-.99-.58.3-.81.82-.46 1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M165.46 139.52s-.3-2.4 1-3.92c1.28-1.52 4.5-2.87 6.5-.3 0 0 1.28 1.94-1.24 3.28-2.51 1.35-2.57-.23-3.33 1.59-.76 1.75-2.29 1.29-2.46 1.64l-.47-2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m168.03 141.86 3.75.36c-.06.52-.58 5.38-1.11 7.2-.23.53-1.23.64-2.17.17-.88-.4-1.4-1.05-1.34-1.58.35-1.11.7-4.33.88-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M161.54 166.46c.52-3.1 2.16-6.74 5.03-11.83 2.4-4.33-2.28-6.26-3.51-3.57-2.75 6.32-4.57 11.18-5.1 15.34h3.58v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#879E0C",
    d: "M189.82 205.52a14.52 14.52 0 1 1 0-29.05 14.52 14.52 0 0 1 0 29.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M197.14 213.48H185.3v-13.06a5.9 5.9 0 0 1 5.91-5.91 5.9 5.9 0 0 1 5.92 5.91v13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M194.03 188.65c-1.4 3.52-5.03 5.39-7.2 4.51-2.17-.88-2.05-4.16-.59-7.67 1.41-3.51 3.93-4.63 6.04-3.75 2.16.88 3.16 3.4 1.75 6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M195.15 190.53c-.36.82-1.59 1.52-2.17 1.28-.59-.23-.47-.93-.12-1.75s1.11-1.4 1.7-1.17c.59.23.88.82.59 1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m193.45 188.77-3.98-.41c-.06.53-.47 5.74-.3 7.67.12.59 1.12.88 2.23.65 1-.24 1.64-.83 1.7-1.35-.12-1.17.11-4.63.35-6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M198.25 213.48c-.53-3.1-2.17-6.73-5.04-11.83-2.4-4.33 2.29-6.26 3.52-3.57 2.75 6.32 4.56 11.18 5.1 15.34h-3.58v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M187.3 182.56c1.99-2.8 5.44-1.58 6.9-.06 1.41 1.53 1.24 4.1 1.24 4.1l-.53 2.52c-.17-.18-.17-.18-.53-.23-.29.11-.58.29-.81.47a.46.46 0 0 0-.24.23c-.06.12-.06.23-.12.3-.11.1-.23.05-.35.05-.06 0-.06 0-.12-.06v-.06c0-.4.47-.76.41-1.23 0-.06-.05-.17-.05-.29a2.87 2.87 0 0 1-.7-.88c-.77-1.46-.89-.7-2.35-1 .06.07.12.12.12.18.23.3.53.53.88.7.06 0 .06.06.06.06a2.5 2.5 0 0 1-1.76-.93c-.12-.12-.18-.24-.3-.35-.11-.06-.17-.06-.29-.12-2.69-1.23-1.46-3.4-1.46-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91AF00",
    d: "M255.7 205.52a14.52 14.52 0 1 1 0-29.05 14.52 14.52 0 0 1 0 29.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M254.93 188.48c-2.1-1.7-5.86-2.05-8.14-.41-2.28 1.64-2.17 5.1-.58 7.26 1.58 2.16 6.38 3.51 10 1.29 2.4-1.47 1.36-5.98-1.28-8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M261.9 213.77h-11.83v-13.06a5.9 5.9 0 0 1 5.91-5.9 5.9 5.9 0 0 1 5.92 5.9v13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M259.09 180.63a3.09 3.09 0 0 0-2.99 1.81c-.4 1.18.47 2.35 1.52 2.76 1.12.4 3.34-.76 3.75-1.88.41-1.17-.82-2.57-2.28-2.69ZM256.57 186.54c-1.58-1.28-4.28-1.64-5.91-.4-1.64 1.22-1.53 3.68-.3 5.32 1.17 1.64 5.39 2.29 7.03 1.12 1.58-1.18 1.11-4.4-.82-6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M254.05 188.71c1.52 3.28 5.04 4.86 7.03 3.92 1.99-.93 1.7-4.04.17-7.26-1.52-3.28-3.92-4.15-5.91-3.22-2 .88-2.81 3.28-1.29 6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M253.11 190.53c.36.76 1.58 1.4 2.11 1.1.53-.23.41-.93.06-1.69-.35-.76-1.11-1.29-1.7-1-.52.24-.82.82-.47 1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M252.65 186.84s-.3-2.4 1-3.93c1.28-1.52 4.5-2.87 6.5-.29 0 0 1.28 1.93-1.24 3.28-2.52 1.35-2.58-.23-3.34 1.58-.76 1.76-2.28 1.29-2.46 1.64l-.46-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m255.22 189.18 3.75.35c-.06.53-.59 5.39-1.11 7.2-.24.53-1.23.65-2.17.18-.88-.41-1.4-1.06-1.35-1.58.35-1.12.7-4.34.88-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M248.72 213.77c.53-3.1 2.17-6.73 5.04-11.83 2.4-4.33-2.28-6.26-3.51-3.57-2.76 6.33-4.57 11.19-5.1 15.35h3.57v.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91AF00",
    d: "M277.24 157.09a14.52 14.52 0 1 1 0-29.05 14.52 14.52 0 0 1 0 29.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M269.1 142.86c-2.05 1.81-3.05 5.39-1.76 7.9 1.23 2.52 4.69 3.05 7.09 1.82 2.4-1.17 4.56-5.74 2.93-9.66-1.06-2.52-5.68-2.29-8.26-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M275.66 146.31c-.47 2.64.93 6.1 3.51 7.32 2.58 1.23 5.5-.52 6.68-2.92 1.17-2.4.05-7.32-3.63-9.43-2.46-1.35-5.98 1.7-6.56 5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M284.44 165h-11.83v-13.06a5.9 5.9 0 0 1 5.92-5.92 5.9 5.9 0 0 1 5.91 5.92v13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M281.63 131.85a3.09 3.09 0 0 0-2.99 1.82c-.4 1.17.47 2.34 1.53 2.75 1.1.4 3.33-.76 3.74-1.88.47-1.1-.82-2.57-2.28-2.69ZM279.11 137.82c-1.58-1.28-4.27-1.64-5.91-.4-1.64 1.22-1.52 3.68-.3 5.32 1.18 1.64 5.4 2.29 7.03 1.11 1.64-1.22 1.17-4.45-.82-6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M276.6 139.93c1.52 3.28 5.03 4.86 7.02 3.92 2-.93 1.7-4.03.18-7.26-1.53-3.28-3.93-4.15-5.92-3.22-1.93.88-2.8 3.28-1.29 6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M275.66 141.75c.35.76 1.58 1.4 2.1 1.1.53-.22.42-.93.06-1.69-.35-.76-1.1-1.29-1.7-1-.52.24-.81.83-.46 1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M275.19 138.06s-.3-2.4 1-3.93c1.28-1.52 4.5-2.87 6.5-.29 0 0 1.28 1.93-1.24 3.28-2.51 1.35-2.57-.23-3.33 1.58-.76 1.76-2.29 1.29-2.46 1.64l-.47-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m277.77 140.4 3.74.35c-.06.53-.58 5.39-1.1 7.2-.24.53-1.24.65-2.18.18-.87-.41-1.4-1.05-1.34-1.58.35-1.06.7-4.34.88-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M271.27 165c.52-3.1 2.16-6.74 5.03-11.83 2.4-4.34-2.28-6.27-3.51-3.58-2.75 6.33-4.57 11.19-5.1 15.35h3.58v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#879E0C",
    d: "M319.8 157.09a14.52 14.52 0 1 1 0-29.05 14.52 14.52 0 0 1 0 29.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M326.42 165.17H314.6v-13.06a5.9 5.9 0 0 1 5.91-5.91 5.9 5.9 0 0 1 5.91 5.91v13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M323.32 140.34c-1.4 3.51-5.03 5.39-7.2 4.51-2.17-.88-2.05-4.16-.59-7.67 1.4-3.51 3.93-4.63 6.03-3.75 2.17.88 3.23 3.34 1.76 6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m322.74 140.46-3.99-.41c-.06.53-.46 5.74-.29 7.67.12.59 1.11.88 2.23.64 1-.23 1.63-.82 1.7-1.34-.12-1.23.17-4.69.35-6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M327.54 165.17c-.53-3.1-2.17-6.73-5.04-11.83-2.4-4.33 2.29-6.26 3.51-3.57 2.76 6.32 4.57 11.18 5.1 15.34h-3.57v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M315.3 141.1c.4-.06.82-.11 1.17.12.12.06.23.18.35.23.06.06.18.06.3.12.17.12.35.3.46.41.18.24.7.88.12 1-.12 0-.3 0-.41-.06-.41-.18-.64-.65-1.05-.82-.06-.06-.12-.06-.24-.12a2.9 2.9 0 0 0-.76-.23c-.12-.06-.23-.06-.35-.12a.32.32 0 0 1-.18-.3c.18-.17.41-.23.59-.23ZM316.59 134.25c.06-.12.17-.23.29-.35-.18-.23-.3-.59-.18-.82.18-.35.59-.41 1-.41 0-.35 0-.7.12-1a.9.9 0 0 1 .76-.52c.3 0 .47.11.76-.12.18-.12.23-.4.4-.53.24-.17.54.12.6.35.05.24.05.53.17.77.12.17.3.35.47.47.23.23.4.46.53.76.81.29 1.52.76 2.05 1.28.35.36.58.77.76 1.23.06 0 .06.06.11.06.12.06.24.06.3.06.52.12.88.59 1 1.06a2.1 2.1 0 0 1-.3 1.46c-.12.23-.3.53-.24.76 0 .12.06.24.12.35.12.35.12.7 0 1.06-.17.29-.52.52-.88.52-.11 0-.23-.06-.35-.11-.17-.06-.47-.12-.7-.24a2.3 2.3 0 0 1-1.64-1.34c-.94-1.82-.88-.18-3.63-1.47-2.75-1.17-1.52-3.28-1.52-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M324.43 141.92c-.35.82-1.58 1.53-2.16 1.3-.59-.24-.47-.95-.12-1.77.35-.82 1.11-1.4 1.7-1.17.58.24.88.82.58 1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M321.86 142.1s.47-.12.11.58c-.35.7-2.8 3-5.32 2.81-2.46-.17-2.52-2.51-2.46-2.98.06-.47.29-.7.58.35.35 1.05 1.4 1.93 2.52 1.81 1.11-.11 3.1-1.17 3.69-1.63.58-.53.88-.94.88-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91AF00",
    d: "M382.05 205.52a14.52 14.52 0 1 1 0-29.05 14.52 14.52 0 0 1 0 29.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M389.95 193.51c.47 3.4-1.1 7.38-3.86 8.44-2.75 1.05-5.91-1.64-7.14-4.92-1.23-3.22.06-9.02 3.98-10.96 2.7-1.28 6.38 3.1 7.02 7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M377.6 213.77h11.83v-13.06a5.9 5.9 0 0 0-5.92-5.9 5.9 5.9 0 0 0-5.9 5.9v13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M379.7 181.16c1.18-.12 2.59.7 3 1.81.4 1.17-.47 2.34-1.53 2.75-1.11.41-3.34-.76-3.75-1.87-.4-1.11.82-2.58 2.29-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M385.45 188.71c-1.53 3.28-5.04 4.86-7.03 3.92-2-.93-1.7-4.04-.18-7.26 1.53-3.28 3.93-4.16 5.92-3.22 1.93.88 2.8 3.28 1.29 6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.38 190.53c-.35.76-1.58 1.4-2.1 1.1-.53-.28-.41-.93-.06-1.69.35-.76 1.11-1.29 1.7-1 .52.24.81.82.46 1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M386.85 186.84s.3-2.4-1-3.93c-1.28-1.52-4.5-2.87-6.5-.29 0 0-1.28 1.93 1.24 3.28 2.52 1.35 2.57-.23 3.33 1.58.77 1.76 2.29 1.29 2.46 1.64l.47-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m384.28 189.18-3.75.35c.06.53.58 5.39 1.11 7.2.24.53 1.23.65 2.17.18.88-.41 1.4-1.06 1.34-1.58-.35-1.12-.7-4.34-.87-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M390.77 213.77c-.52-3.1-2.16-6.73-5.03-11.83-2.4-4.33 2.28-6.26 3.51-3.57 2.75 6.33 4.57 11.19 5.1 15.34h-3.58v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M382 179.7c.99.29 1.98 1.28 1.98 2.34 0 1.05-1.11 1.75-2.16 1.75-1.06 0-2.58-1.58-2.58-2.63 0-1.06 1.46-1.76 2.75-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#879E0C",
    d: "M341.06 205.52a14.52 14.52 0 1 1 0-29.05 14.52 14.52 0 0 1 0 29.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M335.68 214.54h11.82v-13.06a5.9 5.9 0 0 0-5.91-5.92 5.9 5.9 0 0 0-5.91 5.92v13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M338.78 189.65c1.4 3.51 5.04 5.38 7.2 4.5 2.17-.87 2.05-4.15.59-7.66-1.4-3.52-3.93-4.63-6.03-3.75-2.11.88-3.23 3.4-1.76 6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m339.37 189.82 3.98-.4c.05.52.46 5.73.29 7.67-.12.58-1.11.87-2.23.64-1-.23-1.64-.82-1.7-1.35a45.3 45.3 0 0 0-.34-6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M334.56 214.53c.53-3.1 2.17-6.73 5.04-11.82 2.4-4.34-2.28-6.27-3.51-3.58-2.76 6.33-4.57 11.19-5.1 15.35h3.57v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M337.67 191.52c.35.82 1.58 1.52 2.16 1.29.59-.23.47-.94.12-1.76-.35-.82-1.11-1.4-1.7-1.17-.58.24-.88.82-.58 1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M346.8 190.47c-.4-.06-.82-.12-1.17.12-.12.05-.23.17-.35.23-.06.06-.18.06-.3.12-.17.11-.35.29-.46.4-.18.24-.7.88-.12 1 .12 0 .3 0 .41-.06.41-.17.64-.64 1.05-.82.06-.06.12-.06.24-.11.23-.12.47-.18.76-.24.12-.06.23-.06.35-.12a.32.32 0 0 0 .18-.29.84.84 0 0 0-.59-.23ZM345.51 183.62c-.06-.12-.17-.24-.29-.36.18-.23.3-.58.18-.81-.18-.36-.59-.41-1-.41 0-.36 0-.7-.12-1a.9.9 0 0 0-.76-.53c-.3 0-.47.12-.76-.11-.18-.12-.23-.41-.4-.53-.24-.18-.54.12-.6.35-.05.23-.05.53-.17.76-.12.18-.3.35-.47.47-.23.23-.4.47-.53.76-.81.3-1.52.76-2.04 1.29-.36.35-.59.76-.77 1.23-.05 0-.05.06-.11.06-.12.06-.24.06-.3.06-.52.11-.87.58-1 1.05-.1.53.07 1.05.3 1.46.12.24.3.53.24.76 0 .12-.06.24-.12.36-.12.35-.12.7 0 1.05.17.3.52.53.88.53.11 0 .23-.06.35-.12.17-.06.47-.12.7-.23a2.3 2.3 0 0 0 1.64-1.35c.94-1.82.88-.18 3.63-1.46 2.75-1.18 1.52-3.28 1.52-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#879E0C",
    d: "M298.55 205.52a14.52 14.52 0 1 1 0-29.05 14.52 14.52 0 0 1 0 29.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEC58",
    d: "M304.94 214.89H293.1v-13.06a5.9 5.9 0 0 1 5.91-5.92 5.9 5.9 0 0 1 5.92 5.92v13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M301.83 190.06c-1.4 3.51-5.03 5.39-7.2 4.5-2.17-.87-2.05-4.15-.59-7.66 1.4-3.52 3.93-4.63 6.03-3.75 2.17.88 3.17 3.34 1.76 6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m301.19 190.18-3.99-.42c-.05.53-.46 5.74-.29 7.68.12.58 1.11.88 2.23.64 1-.23 1.64-.82 1.7-1.35-.06-1.23.17-4.68.35-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M305.99 214.89c-.53-3.1-2.17-6.74-5.04-11.83-2.4-4.34 2.29-6.27 3.52-3.57 2.75 6.32 4.56 11.18 5.09 15.34h-3.57v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M302.88 191.87c-.35.82-1.58 1.53-2.16 1.3-.59-.24-.47-.94-.12-1.76.35-.82 1.11-1.41 1.7-1.18.58.24.94.82.58 1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M295.1 183.97c.06-.12.17-.24.29-.35-.18-.24-.3-.59-.18-.82.18-.36.59-.41 1-.41 0-.35 0-.7.12-1a.9.9 0 0 1 .76-.53c.3 0 .47.12.76-.11.17-.12.23-.41.4-.53.24-.18.54.12.6.35.05.24.05.53.17.76.12.18.3.35.47.47.23.23.4.47.53.76.82.3 1.52.76 2.05 1.3.35.34.58.75.76 1.22.06 0 .06.06.11.06.12.06.24.06.3.06.52.12.88.58 1 1.05a2.1 2.1 0 0 1-.3 1.47c-.12.23-.3.52-.24.76 0 .11.06.23.12.35.12.35.12.7 0 1.05-.17.3-.52.53-.88.53a.83.83 0 0 1-.35-.12c-.17-.06-.47-.11-.7-.23a2.3 2.3 0 0 1-1.64-1.35c-.94-1.81-.88-.18-3.63-1.46-2.75-1.17-1.52-3.28-1.52-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#879E0C",
    d: "M277.24 253.65a14.52 14.52 0 1 1 0-29.04 14.52 14.52 0 0 1 0 29.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9D772",
    d: "M284.09 260.27h-11.83v-13.06a5.9 5.9 0 0 1 5.92-5.91 5.9 5.9 0 0 1 5.9 5.91v13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M280.99 235.44c-1.4 3.52-5.04 5.39-7.2 4.51-2.17-.88-2.06-4.16-.6-7.67 1.41-3.51 3.93-4.63 6.04-3.75 2.17.88 3.22 3.4 1.76 6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m280.4 235.56-3.98-.41c-.06.53-.47 5.74-.3 7.67.12.59 1.12.88 2.23.64 1-.23 1.64-.82 1.7-1.34-.12-1.23.12-4.69.35-6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEE23E",
    d: "M285.2 260.27c-.52-3.1-2.16-6.73-5.03-11.83-2.4-4.33 2.28-6.26 3.51-3.57 2.75 6.32 4.57 11.18 5.1 15.34h-3.58v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M274.25 229.35c2-2.8 5.45-1.58 6.91-.06.35.35.59.76.76 1.23.06 0 .06.06.12.06.12.06.23.06.3.06.52.12.87.59.99 1.05a2.1 2.1 0 0 1-.3 1.47c-.11.23-.29.47-.23.76 0 .12.06.23.12.35.12.35.12.7 0 1.05-.18.3-.53.53-.88.53a.82.82 0 0 1-.35-.12c-.18-.05-.47-.11-.7-.23a2.3 2.3 0 0 1-1.64-1.35c-.94-1.81-.88-.17-3.63-1.46-2.7-1.23-1.47-3.34-1.47-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M282.1 237.26c-.35.82-1.58 1.52-2.17 1.28-.58-.23-.47-.93-.12-1.75.36-.82 1.12-1.4 1.7-1.17.59.23.88.82.59 1.64ZM148.89 123.83a4.04 4.04 0 1 1 0-8.08 4.04 4.04 0 0 1 0 8.08ZM313.01 243.05a4.04 4.04 0 1 1 0-8.08 4.04 4.04 0 0 1 0 8.08ZM289.42 77.98a4.04 4.04 0 1 1 0-8.08 4.04 4.04 0 0 1 0 8.08ZM131.44 121.37a5.86 5.86 0 1 1 0-11.71 5.86 5.86 0 0 1 0 11.7ZM303.12 233.63a5.86 5.86 0 1 1 0-11.72 5.86 5.86 0 0 1 0 11.72ZM485.52 272.63a5.86 5.86 0 1 1 0-11.71 5.86 5.86 0 0 1 0 11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD886",
    d: "M152 165.46c.99-1 2.69-1 3.68 0 1 1 1 2.7 0 3.7l-3.98 3.97v-7.43l.3-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1C54D",
    d: "M151.46 165.46c-1-1-2.69-1-3.69 0-.99 1-.99 2.7 0 3.7l3.99 3.97v-7.43l-.3-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD886",
    d: "M247.73 74.52c1-1 2.7-1 3.69 0 1 1 1 2.7 0 3.7l-3.98 3.97v-7.43l.29-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1C54D",
    d: "M247.2 74.52c-1-1-2.7-1-3.69 0-1 1-1 2.7 0 3.7l3.98 3.97v-7.43l-.29-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD886",
    d: "M399.15 211.6c1-.99 2.7-.99 3.69 0 1 1 1 2.7 0 3.7l-3.98 3.98v-7.44l.29-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1C54D",
    d: "M398.62 211.6c-1-.99-2.7-.99-3.69 0-1 1-1 2.7 0 3.7l3.98 3.98v-7.44l-.29-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M452.72 342.67c.06-.06.12-.17.24-.23.47-.76.23-1.82-.53-2.29l-10.01-6.38a1.68 1.68 0 0 0-2.29.53c-.47.76-.23 1.81.53 2.28l10.01 6.38c.65.36 1.52.24 2.05-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M452.55 339.63s3.74 2.22 3.16 3.04c-.65.82-10.48 11.71-11.07 11.3-1.87-1.4 4.92-11.53 5.92-12.24 1-.7 1.46-2.4 1.99-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M368.58 209.74s-6.62-5.33-8.72-4.86c-2.11.47 3.63 6.27 8.72 6.97v-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5E370",
    d: "M369.8 208.87c-.93 1-1.92 1.93-2.86 2.87 14.81 15.34 27.29 18.15 46.2 9.36 2.87-1.34 2.75-2.45 1.4-4.74.24-.4.3-.4 0 0-1.34-2.28-2.16-2.46-5.15-1.05-19.14 8.9-22.66 6.09-39.58-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M403.89 358.83c.12 0 .23 0 .35-.05a1.66 1.66 0 0 0 1.29-1.94l-2.34-11.65a1.66 1.66 0 0 0-1.94-1.29 1.66 1.66 0 0 0-1.29 1.93l2.35 11.66c.11.82.76 1.34 1.58 1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404908",
    d: "M400.26 352.1c1.75-.06 3.51-.23 5.27-.47-5.21-27.93-9.2-65.47 4.8-91.64-4.28-2.11-8.5-4.1-12.77-6.15-10.3 22.78-1.58 74.2 2.7 98.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596613",
    d: "M446.28 341.62a78.77 78.77 0 0 0 3.57-4.16c-31.15-23.66-40.22-42.4-35.01-81.98a599.9 599.9 0 0 0-14.29-2.11c.53 43.74 13.4 61.37 45.73 88.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M405.94 356.67s1 4.21 0 4.33c-1 .12-15.75.59-15.81-.12-.3-2.34 11.7-4.45 12.88-4.21 1.17.23 2.81-.65 2.93 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBEBB5",
    d: "M414.66 262.74c-2.28-.88-5.56-1.76-11.3-2a56.1 56.1 0 0 0-9.37.3c10.01-21.55 11.77-32.27 10.9-38.36a8.26 8.26 0 0 1 3.16-7.9l.93-.7a7.45 7.45 0 0 1 11.83 4.45c.35 1.81.64 3.86.76 6.2.53 11.19-.94 23.25-6.9 38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M390.54 246.75s-7.85-4.27-9.96-3.4c-2.05.89 4.98 5.8 10.37 5.51l-.41-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5E370",
    d: "M389.37 245.87a50.71 50.71 0 0 1-1.94 4.45c27.88 1.94 35.08-3.8 33.2-29.57-.29-3.92-1.17-4.33-4.56-3.45-2.52.7-2.46 2.1-2.17 5.62 2.1 22.95.88 21.6-24.53 22.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596613",
    d: "M400.08 240.6c.7.24 1.35.47 2.05.65 1.93-10.54 2.23-18.8 5.8-24.83 2.46-4.22 5.38-7.2 12.7-9.43.06-3.22.82-5.97.82-5.97l-1.7-.41c-7.55 3.75-11.94 7.61-14.57 12.41-3.75 6.68-4.04 15.17-5.1 27.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93BC32",
    d: "M402.01 240.02s1.23 2.57.59 2.75c-.64.23-9.96 2.4-10.07 2-.47-1.47 6.9-4.4 7.67-4.4.76 0 1.7-.76 1.81-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596613",
    d: "M430.88 240.84c.64-.3 1.35-.59 2-.82-5.45-9.25-10.67-15.64-11.95-22.55-.88-4.8-.65-8.96 3.4-15.4-2.06-2.46-3.29-5.03-3.29-5.03l-1.52.76c-3.28 7.79-4.04 13.58-2.93 18.91 1.64 7.5 6.97 14.11 14.3 24.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93BC32",
    d: "M432 239.14s2.57 1.17 2.22 1.7c-.35.58-5.92 8.31-6.33 8.14-1.34-.76 2.35-7.85 2.93-8.32.59-.52.76-1.7 1.17-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0DA15",
    d: "M404.36 207.7c1.1 1.99 3.86 2.63 4.97 4.1.94 1.28 5.22-1.59 5.92 1.7 2.87 13.05 11.24 7.66 11.24 7.66-2.05-3.16-2.28-9.66-2.23-14.4.06-3.22.36-5.62.36-5.62l-2.29-.59-8.08-2c-5.8 5.22-9.9 9.14-9.9 9.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M397.04 175.9s-1.35-4.86-2.52-5.4c-1.17-.52-.41 4.28 1.81 6.4l.7-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5E370",
    d: "M397.04 174.73c-.7.4-1.35.81-2 1.17 6.74 11.18 15.29 16.57 23.84 4.04 1.29-1.94.64-1.94-.47-2.75-.12-.36 0-.24 0 0-1.11-.82-1.82-1.18-2.87.7-6.97 12.06-11.89 4.45-18.5-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF7A6",
    d: "M424.15 182.46c.35-1.64.35-2.17.29-3.52-.18-4.04-4.1-5.33-7.5-4.1-.17.06-.46.12-.7.35-2.22 1.94-2.98 2.05-3.8 5.69-1.35 5.9-1.47 14.05-2.4 20.55 3.63-.18 6.61 1 10.54 1.46.52.06 3.57-.58 4.5-.47.65-6.85-2.22-13.46-.93-19.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M418.59 168.33c-2.22-2.83-2.28-6.47-.14-8.15 2.14-1.68 5.67-.74 7.88 2.08 2.22 2.83 2.28 6.48.14 8.15-2.14 1.68-5.67.75-7.88-2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M422.45 168.05c-1.46 3.75-5.33 5.74-7.61 4.86-2.29-.94-2.17-4.4-.7-8.14 1.46-3.75 4.1-4.92 6.38-3.98 2.34.82 3.4 3.51 1.93 7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m421.8 168.17-4.21-.35c-.06.58-.47 6.09-.23 8.14.17.64 1.22.93 2.34.64 1.05-.23 1.75-.88 1.81-1.46-.17-1.3.12-4.92.3-6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M415.25 161.6c.11-.1.17-.23.29-.34-.18-.3-.35-.59-.23-.88.17-.35.64-.41 1.05-.47-.06-.35 0-.7.12-1.05.17-.3.46-.59.82-.59.35 0 .52.12.82-.12.17-.17.23-.4.4-.58.24-.18.53.12.65.35.06.3.06.59.18.82.11.23.29.35.46.53.24.23.41.52.59.82.88.29 1.64.82 2.17 1.4.35.41.64.82.82 1.29.06.06.11.06.11.06.12.06.24.06.36.06.52.11.93.58 1.05 1.1.12.54 0 1.12-.3 1.59-.11.23-.29.53-.29.82 0 .12.06.23.12.35.12.35.18.76 0 1.11-.18.35-.53.59-.94.53-.11 0-.23-.06-.4-.12-.18-.06-.48-.11-.77-.23a2.32 2.32 0 0 1-1.75-1.4c-1-1.94-.94-.18-3.87-1.53-2.75-1.23-1.46-3.51-1.46-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M423.62 169.75c-.35.88-1.64 1.64-2.28 1.4-.65-.23-.53-1-.18-1.87.35-.88 1.17-1.46 1.82-1.23.64.18 1 .82.64 1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M422.16 155.7c1.99-1.24 5.2-1.24 7.02.46 1.82 1.64 1.35 4.63-.23 6.33-1.58 1.7-5.86 2.4-8.73.11-1.93-1.52-.58-5.32 1.94-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M433.8 155.58s-.46-5.04-1.51-5.74c-1.06-.7-1.18 4.16.64 6.62l.88-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5E370",
    d: "m432.23 155.22 2.28-.17c-.23 14.05 1.7 17.4-11.12 24.71-1.94 1.11-2 .53-2.64-.94-.3-.05-.3 0 0 0-.64-1.46-.53-1.87 1.35-2.75 12.35-5.8 8.55-8.43 10.13-20.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M416.48 204.77c-1.88 4.62-6.62 7.08-9.43 5.91-2.81-1.17-2.63-5.44-.76-10.07 1.87-4.63 5.15-6.03 7.96-4.92 2.81 1.11 4.1 4.45 2.23 9.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M417.94 207.23c-.4 1.05-2.05 1.99-2.87 1.7-.76-.3-.64-1.3-.17-2.35.4-1.05 1.46-1.81 2.28-1.52.76.35 1.17 1.05.76 2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M418.35 202.13s.23-3.34-1.64-5.39c-1.87-1.99-6.44-3.63-9.07.06 0 0-1.64 2.81 1.93 4.51 3.57 1.7 3.51-.47 4.74 1.93 1.23 2.4 3.28 1.58 3.51 2.11l.53-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m415.66 204.94-5.21-.53c-.06.7-.65 7.5-.36 10.08.18.76 1.47 1.17 2.93.82 1.29-.3 2.17-1.06 2.23-1.82-.18-1.52.17-6.03.4-8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M414.25 206.64c-.94-.64-1.46.18-3.1 1.58-1.64 1.35-4.92 1.76-5.97-2.46-.65-2.7-1.35 2.05-1.35 2.05.12 2.28 1 3.51 2.63 4.22 2.35.94 5.57.12 8.14-2.17.3-1.23.3-2.75-.35-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M405 205.65s.06 0 .18.05c1 .3 5.5 1.82 6.2 3.4.82 1.81-2.34-.3-3.33-1.35-1-1.05-2-.7-2.87-.82-.94-.06-1.53-1.11-.18-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBEBB5",
    d: "m486.1 352.28 2.63-1.88c-.29-.47-29.57-44.33-31.73-74.9l-5.39.24c2.22 31.5 33.2 74.72 34.49 76.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBEBB5",
    d: "M433.1 358.13c.18-.52 18.33-53.05 19.56-82.45l-5.38-.12c-1.23 29-17.1 81.1-17.28 81.63l3.1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M487.62 348s3.34 2.17 2.75 2.87c-.58.7-10.07 10.25-10.54 9.84-1.64-1.35 4.92-10.3 5.86-10.9.94-.58 1.4-2.1 1.93-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M433.75 195.28s.41-7.73-1.05-9.08c-1.47-1.28-2.7 6.04-.53 10.2l1.58-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5E370",
    d: "M434.57 194.99c-1.23-.12-2.52-.18-3.75-.24-.4 19.91 1.4 28.64 19.62 38.07 2.8 1.46 3.51.4 4.1-1.94.52.06.52.06 0 0 .64-2.34-.18-2.92-2.58-4.15-15.98-8.03-15.93-14.7-17.39-31.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404908",
    d: "M459.16 314.27c-.93.65-1.81 1.35-2.75 2.05a42.53 42.53 0 0 1-6.73 3.87c-1.4.64-2.81 1.28-4.28 1.7a17.2 17.2 0 0 1-6.9.23c3.1-20.8 1.52-39.82 8.2-59.56.63.24 1.34.53 1.98.76 0-.76-.06-1.52-.06-2.28 4.28.47 8.61 1 12.88 1.52-1.1 19.62 1.94 34.5 7.85 48.96-3.57-.18-7.2.76-10.19 2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M452.55 204.36c1.46.05 3.16 1.23 3.51 2.75.35 1.52-.94 2.87-2.34 3.22-1.4.35-4.1-1.4-4.45-2.93-.35-1.52 1.4-3.1 3.28-3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M457.64 202.95c2.87-1.81 7.61-1.7 10.25.7 2.63 2.4 1.99 6.74-.35 9.26-2.29 2.51-8.55 3.45-12.77.11-2.75-2.28-.82-7.78 2.87-10.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M454.83 212.15c2.17-1.41 5.56-1.41 7.44.35 1.87 1.75 1.34 4.86-.41 6.73-1.76 1.87-7.09 2.05-8.96.35-1.82-1.76-.76-5.68 1.93-7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M457.64 215.19c-2.4 3.87-7.03 5.33-9.43 3.87-2.34-1.47-1.52-5.33.88-9.2 2.4-3.86 5.56-4.63 7.9-3.16 2.35 1.46 3.05 4.63.65 8.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M458.58 217.65c-.59.88-2.17 1.52-2.81 1.11-.65-.4-.35-1.23.17-2.1.59-.88 1.64-1.41 2.29-1 .64.3.88 1.05.35 1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M459.75 213.08s.7-2.99-.64-5.1c-1.41-2.1-5.22-4.27-8.14-1.34 0 0-1.88 2.28 1.05 4.33 2.93 2.05 3.22.12 3.98 2.46.7 2.34 2.7 1.94 2.81 2.46l.94-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF7A6",
    d: "M444.06 270.88c3.57.53 6.5-.41 9.72-1.88 2.51-1.1 5.56-1.4 8.14-2.05 3.1-10.89 2.75-29.16-.7-36.77-3.05-6.68-3.17-5.68-4.52-6.38a5.12 5.12 0 0 0-5.73.23c-.06 0-.06.06-.12.06-1.93 1.46-2.46 5.15-3.16 8.96-.7 3.8-2.11 2.93.46 9.95 1.18 2.93-3.5 22.14-4.1 27.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m456.18 215.66-4.8-.18c0 .65-.12 6.85.29 9.2.23.7 1.4.93 2.7.58 1.1-.35 1.92-1.11 1.92-1.75-.23-1.41-.23-5.57-.11-7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M434.04 355.79s.94 3.86 0 3.98c-.93.12-14.34.53-14.4-.12-.3-2.1 10.72-4.1 11.77-3.86 1.05.23 2.52-.53 2.63 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M484.1 261.51s-2.1 7.85-.93 9.55c1.23 1.63 4.1-5.63 2.75-10.37l-1.81.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5E370",
    d: "M483.29 263.32c1.29.18 2.4.42 3.86.6 1.29-25.66-4.74-30.23-27.93-37.9-3.57-1.17-5.74 4.92.41 6.27 21.5 4.8 22.13 8.67 23.66 31.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M489.85 270.82s-3.34-5.03-4.8-5.21c-1.53-.12 1.1 5.03 4.39 6.62l.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0DA15",
    d: "M519.18 282.47c2.4-.29 4.04-1 3.05-3.74-.53-1.47-2.17-2.17-4.75-1.76-13.23 2.1-19.9-1.35-28.34-8.08l-2.69 3.28c9.07 7.79 20.08 11.7 32.73 10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M553.55 336.06c0-.06.06-.18.06-.3.06-.76-.47-1.4-1.23-1.52l-9.9-.88c-.75-.06-1.4.47-1.52 1.23-.06.76.47 1.4 1.23 1.52l9.9.88c.7.06 1.29-.35 1.46-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93BC32",
    d: "M552.32 333.65s2.99.18 2.87.88c-.12.7-2.7 10.43-3.16 10.37-1.58-.3-.64-8.55-.23-9.31.35-.76.06-1.94.52-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M513.27 359.54h.29c.76-.06 1.35-.7 1.29-1.47l-.47-9.9a1.38 1.38 0 1 0-2.75.18l.47 9.9c.05.64.52 1.17 1.17 1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93BC32",
    d: "M516.02 357.6s.7 2.93 0 3c-3.92.46-10.83 0-10.83-.07-.18-1.58 8.02-3.04 8.84-2.93.82.18 1.93-.4 1.99 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404908",
    d: "M518.07 308.94c-3.87-.88-5.1-1.17-8.96-1.93-2.63 15.1.12 30.86 1.7 47.26h5.85c-1.93-16.81-1.93-32.91 1.4-45.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596613",
    d: "M522.87 306.77c-3.28-.58-6.26-1.87-9.6-2.28 3.28 24.19 10.54 29.98 34.2 33.15.4-1.64.75-3.28 1.16-4.92-20.43-2.05-30.27-2.05-25.76-25.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED976D",
    d: "M518.3 278.2c.3-.47.3-.47 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7E751",
    d: "M525.39 286.22c.82-2.17 1.23-2.63 1.46-4.27.35-2.46-.47-4.34-1.93-5.45a7.24 7.24 0 0 0-5.74-1.17c-.06 0-.53 0-1.23.23-1.35.47-3.63 1.88-5.21 6.39-3.69 10.42-4.45 16.86-4.8 26.47l15.34-1.3c-.76-7.31-1.17-12.58 2.1-20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M523.8 269.06c-1.57 3.87-5.56 5.92-7.9 4.92-2.34-.93-2.22-4.56-.64-8.43s4.27-5.04 6.67-4.1c2.35 1 3.46 3.75 1.88 7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M525.39 266.78s.17-2.81-1.4-4.5c-1.59-1.7-5.4-3.05-7.56.05 0 0-1.35 2.34 1.58 3.75 2.99 1.4 2.93-.41 3.98 1.64 1 1.99 2.75 1.34 2.93 1.75l.47-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m523.16 269.18-4.33-.4c-.06.58-.53 6.26-.3 8.42.18.65 1.24.94 2.4.7 1.06-.23 1.82-.87 1.88-1.52-.17-1.34.12-5.1.35-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M525.04 271.06c-.36.87-1.7 1.7-2.4 1.4-.7-.3-.53-1.05-.18-1.93.35-.88 1.23-1.52 1.87-1.3.65.24 1.06.95.7 1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M517.66 265.9s-2.99-.88-3.87-3.8c0 0 3.28 1.63 3.87 1.58.58-.06.4 2.46.4 2.46l-.4-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M516.43 264.79s-2.4-2.93-1.52-5.97c0 0 .4 2.34 2.75 3.69 2.34 1.34-1.23 2.28-1.23 2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M516.6 263.56s-.64-2.46.77-4.04c0 0-.41 1.52.64 2.99 1.05 1.46-1.4 1.05-1.4 1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M530.77 304.38s-5.62 2.16-6.09 3.63c-.46 1.46 5.16 0 7.38-2.87l-1.28-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0DA15",
    d: "M522.99 279.49c-1.17 2.1-.76 2.4 1.93 4.21 13.06 8.96 12.06 13.7 4.98 19.97l2.51 2.99c9.73-8.67 10.72-17.04-5.26-28.4-3.17-2.23-3-.88-4.16 1.23Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M558 45H79v322h479z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.487b5e27786d3bd2c988fdb6ad83e098.svg";
export { ForwardRef as ReactComponent };